import s1 from "../assets/s1.png";
import s2 from "../assets/s2.png";
import s3 from "../assets/s3.png";
import s4 from "../assets/s4.png";
import s5 from "../assets/s5.png";
import s6 from "../assets/s6.png";
import s7 from "../assets/s7.png";
import s8 from "../assets/s8.png";
import s9 from "../assets/s9.png";
import s10 from "../assets/s10.png";
import s11 from "../assets/s11.png";
import s12 from "../assets/s12.png";

export const SCHOOLS_SYLLABUS_DATA = [
  {
  id: "school-1",
  title: "Coding & App Development",
  hours: "50 hrs",
  image: s1,
  modules: [
    "Fundamentals of app development & coding",
    "Interactive storytelling & game creation",
    "Android app essentials",
    "Sensor integration",
    "Advanced game design",
  ],
 outcomes: [
  "Build strong foundational skills in coding and mobile app development",
  "Foster creativity and innovation through hands-on, project-based learning",
  "Design and develop interactive apps, animations, and simple games",
  "Enhance problem-solving and logical thinking abilities",
  "Apply user-focused design thinking principles in app creation",
  "Gain confidence using modern digital tools and technologies",
  "Strengthen analytical skills by breaking down complex problems",
  "Prepare for advanced learning and future technology careers",
]

},
    
    {
      id: "school-2",
      title: "Web Development",
      hours: "60 hrs",
      image: s2,
      modules: [
        "Front-end basics",
        "Responsive & interactive design",
        "Bootstrap design",
        "Event-based dynamic web design",
        "JavaScript essentials",
        "Web app projects",
        "Firebase backend integration",
      ],
 outcomes: [
  "Gain proficiency in front-end development using HTML, CSS, and JavaScript",
  "Build dynamic and responsive web applications",
  "Integrate APIs for real-world data handling",
  "Use Firebase services for authentication and real-time databases",
  "Manage and store data securely using serverless architecture",
  "Optimize performance and application efficiency",
  "Deploy web applications for public access",
  "Apply security, testing, and version control best practices",
]

    },
    {
      id: "school-3",
      title: "Web Gadget Collection using JS & API",
      hours: "10 hrs",
      image: s3,
      modules: [
        "Currency converter",
        "GitHub profile finder",
        "Image gallery",
        "Joke teller",
        "Movie search",
        "Place finder",
        "Random quote generator",
        "Recipe finder",
        "Simple video player",
        "Simple weather app",
      ],
 outcomes: [
  "Gain strong proficiency in JavaScript for web development",
  "Understand how to integrate APIs into web applications",
  "Build real-world web gadgets such as converters, search tools, and utilities",
  "Develop skills in DOM manipulation and asynchronous programming",
  "Create interactive and dynamic user interfaces",
  "Strengthen logical thinking and problem-solving abilities",
  "Build a project-based portfolio showcasing frontend skills",
  "Prepare for advanced front-end development concepts",
]

    },
    {
      id: "school-4",
      title: "Web App Development with HTML5 & JS",
      hours: "10 hrs",
      image: s4,
      modules: [
        "Canva app",
        "Music app",
        "Simple animation app",
        "Guess the number",
        "Dinosaur game",
        "Rock–Paper–Scissors",
        "Flappy Bird",
        "Snake",
        "Whack-a-Mole",
        "Bouncing ball",
      ],
      outcomes: [
  "Gain proficiency in web app development using HTML5 and JavaScript",
  "Build a creative project portfolio including apps and games",
  "Design interactive user interfaces using HTML5 elements, canvas, and audio",
  "Develop game development skills including logic and user interaction",
  "Strengthen problem-solving abilities through app and game challenges",
  "Understand deployment and distribution of web-based applications",
  "Acquire practical skills in interactive and multimedia web development",
]

    },
    {
      id: "school-5",
      title: "Web App Development with HTML5 & CSS Animation",
      hours: "10 hrs",
      image: s5,
      modules: [
        "Car scene",
        "Button animation",
        "Navbar animation",
        "Flower, cat, chick, marine scenes",
        "Pineapple & cake animation",
      ],
      outcomes: [
  "Integrate animations effectively into web applications",
  "Master CSS keyframe animations, transitions, and transforms",
  "Design dynamic and visually engaging user interfaces",
  "Improve user experience through smooth motion and interactions",
  "Optimize animation performance across different devices",
  "Apply modern UI animation best practices in web development",
]

    },
    {
      id: "school-6",
      title: "AR / VR",
      hours: "30 hrs",
      image: s6,
      modules: [
        "AR/VR basics",
        "Interactive 3D world building",
        "Advanced modeling & storytelling",
      ],
     outcomes: [
  "Gain a strong foundation in augmented and virtual reality concepts",
  "Develop practical skills using the CoSpaces.io platform",
  "Create and share immersive 3D worlds and virtual experiences",
  "Build interactive AR and VR projects through scripting and design",
  "Enhance creative storytelling using immersive technologies",
  "Understand real-world applications of AR and VR across industries",
  "Develop skills aligned with future-ready technologies",
]

    },
    {
      id: "school-7",
      title: "Python for Kids",
      hours: "20 hrs",
      image: s7,
      modules: [
        "Python basics",
        "Lists/tuples/sets/dictionary",
        "Functions & OOP",
        "File & exception handling",
      ],
     outcomes: [
  "Build a strong foundation in Python programming basics",
  "Develop logical thinking and problem-solving skills",
  "Learn to break complex problems into simple steps",
  "Create games, animations, and simple applications",
  "Encourage creativity and imagination through coding projects",
  "Gain confidence in using technology and programming tools",
]

    },
    {
      id: "school-8",
      title: "Android App Development using AI (MIT)",
      hours: "30 hrs",
      image: s8,
      modules: ["MIT App Inventor basics", "AI components", "Build AI-powered app"],
      outcomes: [
  "Gain a strong foundation in Android app development",
  "Build mobile apps using MIT App Inventor’s visual programming",
  "Integrate AI features such as chatbots, speech, and image recognition",
  "Design and develop AI-powered mobile applications",
  "Enhance problem-solving and creative thinking skills",
  "Create a project-based portfolio application",
  "Build confidence in emerging AI-driven technologies",
]

    },
    {
      id: "school-9",
      title: "Space Science Course",
      hours: "30 hrs",
      image: s9,
      modules: [
        "Space simulations & games",
        "3D modeling (TinkerCAD)",
        "Space shooter apps",
        "Solar system animation",
        "AI chatbot for NASA",
      ],
      outcomes: [
  "Understand basic space science concepts through coding activities",
  "Apply basic coding skills to create space-themed games and simulations",
  "Model Sun–Earth relationships including day–night cycles and seasons",
  "Develop problem-solving and critical thinking skills",
  "Create simple space simulators and exploration games",
  "Build curiosity about space, planets, rockets, and the solar system",
]

    },
    {
      id: "school-10",
      title: "Tkinter – Python GUI",
      hours: "30 hrs",
      image: s10,
      modules: ["Tkinter basics", "Widgets & layouts", "Events & actions", "Images & customization"],
      outcomes: [
    "Understand core programming concepts and logic building",
    "Build interactive mobile and web applications",
    "Create simple games and storytelling apps",
    "Gain hands-on experience with Android app development",
    "Improve problem-solving and computational thinking skills",
    "Apply creativity using sensors and real-world interactions",
    "Develop confidence to work on advanced coding projects"
  ]
  
    },
    {
      id: "school-11",
      title: "Sugarlabs Turtle",
      hours: "20 hrs",
      image: s11,
      modules: ["Basic drawing", "Loops & conditions", "Symmetry & functions", "Fractals & animations"],
 outcomes: [
  "Draw simple and complex shapes using Turtle Art",
  "Apply programming concepts such as loops, conditions, and variables",
  "Create interactive digital art and animations",
  "Develop custom functions and fractal designs",
  "Build logical thinking and problem-solving skills",
  "Complete and present a final creative coding project",
]

    },
     {
    id: "comm-1",
    title: "Communication & Personality Development",
    hours: "30 hrs",
    image: s12,
modules: [
  "Introduction to workplace communication",
  "Product and service communication",
  "Time management and scheduling conversations",
  "Telephone, virtual and remote communication skills",
  "Understanding company structure and operations",
  "Collaboration and teamwork communication",
  "Social and interpersonal workplace communication",
  "Presentation skills and information sharing",
  "Seeking assistance and professional problem-solving",
],
 outcomes: [
  "Communicate confidently in professional and corporate environments",
  "Improve fluency and clarity in workplace English conversations",
  "Handle meetings, calls, and presentations effectively",
  "Strengthen problem-solving and decision-making communication",
  "Build strong professional relationships and networks",
  "Enhance career growth and promotion opportunities",
  "Develop global communication competence for multinational workplaces",
],
idealFor: [
  "Working professionals",
  "Freshers entering corporate roles",
  "Job seekers preparing for interviews",
  "Individuals aiming for career growth",
  "Professionals working in global or client-facing roles",
]
  },
  ];
